import React from 'react';
import {
  useCurrentWallet,
  useGlobalValueStore,
  useWallets,
} from '@bitbot/model';
import { HideBalance } from '@/ui/svg';
import {
  eToNumber,
  formatQuoteNumber,
} from '@bitbot/shared/utils/quote-value';

export default function TotalUsdValue({
  canClick = false,
  isTotal = false,
}: {
  canClick?: boolean;
  isTotal?: boolean; //true显示全部， false显示当前钱包
}) {
  const { unverifiedTotal } = useCurrentWallet();
  const { totalValueUSD } = useWallets();
  const { showBalance, setShowBalance } = useGlobalValueStore();
  const total = unverifiedTotal as {
    balance: number;
  };
  const balance = isTotal
    ? totalValueUSD.toString()
    : total
    ? total.balance
      ? eToNumber(total.balance)
      : ''
    : '';

  const prefix = balance.split('.')[0];
  let suffix = balance.split('.')[1]
    ? balance.split('.')[1].substring(0, 2)
    : '';
  suffix = +suffix === 0 ? '' : suffix;
  if (!showBalance)
    return (
      <div
        onClick={() => {
          if (canClick) {
            setShowBalance(!showBalance);
          }
        }}
        className="h-11 flex items-center"
      >
        <HideBalance className="text-primary" />
      </div>
    );
  return (
    <div
      onClick={() => {
        if (canClick) {
          setShowBalance(!showBalance);
        }
      }}
      className="flex"
    >
      {+balance === 0 ? (
        <div className="h-9 mt-2 font-bold flex items-center text-4xl">
          $0<span className="text-tertiary">.00</span>
        </div>
      ) : (
        <div className="h-9 mt-2 font-bold flex items-center text-4xl cursor-pointer">
          ${formatQuoteNumber(prefix ? +prefix : 0)}
          <span className="text-tertiary">{suffix && `.${suffix}`}</span>
        </div>
      )}
    </div>
  );
}
